var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFfLogo2024Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#08152C",
    fillRule: "evenodd",
    d: "m9.778 10.534-5.87-5.87-3.913 3.913 5.87 5.87-3.735 3.735 3.913 3.913 7.648-7.648-3.913-3.913Zm5.87-5.87 9.782 9.783-13.518 13.518L8 24.052l9.605-9.605-5.87-5.87 3.913-3.913Zm17.608 5.87L23.65.928l-3.913 3.913 9.605 9.604-9.605 9.605 3.913 3.913 9.605-9.605 3.913-3.912-3.913-3.914Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfLogo2024Black);
export default __webpack_public_path__ + "static/media/FFLogo2024_Black.a52144b9304fa1bda7f05d38826774b4.svg";
export { ForwardRef as ReactComponent };